import { Button, Checkbox, Col, Form, Input, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react';

import useTranslate from '@core/hooks/useTranslate';
import { DownloadOutlined } from '@ant-design/icons';
import SubmitButton from '@root/core/components/Button';
import ButtonSubmit from './ButtonSubmit';
import { Link } from 'react-router-dom';
import CountryPhoneInput from '@root/core/components/CountryPhoneInput';

interface Props {
  formData:
    | {
        accountState: string;
        address: string;
        city: string;
        country: string;
        countryCode: string;
        googleMapAddress?: string;
        countryName: string;
        description: string;
        detailAddress: string;
        detailAddress2: string;
        email: string;
        id: number;
        imgUrls: {}[];
        license: any;
        majorStorageProducts: {}[];
        managerName: string;
        name: string;
        paypalId: string;
        phoneNumber: string;
        postalCode: string;
        scaleArea: number;
        scaleAreaUnit: string;
        specialCargoStorage: boolean;
        state: string;
        street: string;
        updatedAt: string;
        websiteUrl: string;
      }
    | undefined;
}

const LogisticInformation = ({ formData }: Props) => {
  const getStorageProduct = formData?.majorStorageProducts
    ?.map((pro: any) => pro.majorStorageProductName)
    .join(', ');

  const downloadFile = (url: any) => {
    window.location.href = url;
  };

  const [form] = Form.useForm();

  useEffect(() => {
    form.setFieldsValue({
      accountState: formData?.accountState,
      address: formData?.address,
      city: formData?.city,
      countryCode: formData?.countryCode,
      country: formData?.country,
      countryName: formData?.countryName,
      description: formData?.description,
      googleMapAddress: formData?.googleMapAddress,
      detailAddress: formData?.detailAddress,
      detailAddress2: formData?.detailAddress2,
      email: formData?.email,
      id: formData?.id,
      imgUrls: formData?.imgUrls,
      license: formData?.license?.fileName,
      majorStorageProducts: getStorageProduct,
      managerName: formData?.managerName,
      name: formData?.name,
      paypalId: formData?.paypalId,
      phoneNumber: formData?.phoneNumber,
      postalCode: formData?.postalCode,
      scaleArea: formData?.scaleArea,
      scaleAreaUnit: formData?.scaleAreaUnit,
      specialCargoStorage: formData?.specialCargoStorage,
      state: formData?.state,
      street: formData?.street,
      updatedAt: formData?.updatedAt,
      websiteUrl: formData?.websiteUrl
    });
  });

  const [t] = useTranslate();

  const onFinish = (values: any) => {
    console.log('Success:', values);
  };

  const onFinishFailed = (errorInfo: any) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <>
      <div
        style={{
          padding: '1rem',
          backgroundColor: 'white'
        }}
        id="busk-DetailForm"
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          form={form}
        >
          <Row gutter={24}>
            {/* Left Form */}
            <Col flex={1}>
              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item label="물류센터명" name="name">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={24}>
                  <Form.Item label="물류센터 관리자명" name="managerName">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>

              <Row>
                <Col span={24}>
                  <Form.Item>
                    <Input.Group size="large">
                      <Row gutter={24}>
                        <Col
                          id="form-country-container"
                          className="country-phone-container"
                        >
                          <CountryPhoneInput
                            placeholder="Please enter number only"
                            title="연락처"
                            disabled={true}
                            name="phoneNumber"
                            defaultCode={formData?.countryCode}
                            onchange={(value: any) => {
                              form.setFieldsValue({ countryCode: value });
                            }}
                            phoneNumberRules={[
                              {
                                required: true,
                                message: 'Phone number is required'
                              }
                            ]}
                          />
                        </Col>
                        {/* <Col flex="auto">
                          <Input value={formData?.phoneNumber} />
                        </Col> */}
                      </Row>
                    </Input.Group>
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="이메일" name="email">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="비밀번호" name="password">
                    <Input type="password" />
                  </Form.Item>
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  <Form.Item label="특수화물 보관" name="specialCargoStorage">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>

            {/* Right Form */}
            <Col flex={4}>
              <Row style={{ padding: '8px 0' }}>
                <Col>물류센터 이미지</Col>
              </Row>
              <Row gutter={12}>
                {formData?.imgUrls?.map((img: any) => (
                  <Col span={6} key={img.id}>
                    <img
                      src={img.url}
                      alt=""
                      style={{
                        width: '100%',
                        height: '200px',
                        objectFit: 'cover'
                      }}
                    />
                  </Col>
                ))}
              </Row>
              <Row align="bottom" gutter={24}>
                <Col flex={0.4}>
                  <Form.Item label="사업자등록증" name="license">
                    <Input />
                  </Form.Item>
                </Col>
                <Col flex="150px">
                  <Form.Item>
                    <Button
                      className="busk-download"
                      type="primary"
                      shape="round"
                      size="middle"
                      icon={<DownloadOutlined />}
                      onClick={() => downloadFile(formData?.license.url)}
                    >
                      다운로드
                    </Button>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12}>
                  <Row gutter={12}>
                    <Col span={6}>
                      <Form.Item label="규모 / 면적" name="scaleArea">
                        <Input />
                      </Form.Item>
                    </Col>
                    <Col span={6}>
                      <Form.Item
                        name="scaleAreaUnit"
                        className="logistic-information"
                      >
                        <Select value={formData?.scaleAreaUnit} disabled>
                          <Select.Option value={formData?.scaleAreaUnit}>
                            {formData?.scaleAreaUnit}
                          </Select.Option>
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col flex="auto">
                      <Form.Item label="Paypal ID" name="paypalId">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={12}>
                  <Row>
                    <Col span={24}>
                      <Form.Item label="웹사이트 URL" name="websiteUrl">
                        <Input />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>

              <Row gutter={24}>
                <Col span={12}>
                  <Form.Item label="주요 취급상품" name="majorStorageProducts">
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row>
            <Col span={20}>
              <Form.Item label="물류센터 국가/주소">
                <Input.Group size="large">
                  <Row gutter={18}>
                    <Col span={5}>
                      <Input value={formData?.country} />
                    </Col>
                    <Col span={13}>
                      <Input value={formData?.googleMapAddress} />
                    </Col>
                  </Row>
                </Input.Group>
                <Input.Group size="large" style={{ marginTop: 13 }}>
                  <Row gutter={18}>
                    <Col span={9}>
                      <Input value={formData?.detailAddress} />
                    </Col>
                    <Col span={9}>
                      <Input value={formData?.detailAddress2} />
                    </Col>
                  </Row>
                </Input.Group>
                <Input.Group size="large" style={{ marginTop: 13 }}>
                  <Row gutter={18}>
                    <Col span={6}>
                      <Input value={formData?.city} />
                    </Col>
                    <Col span={6}>
                      <Input value={formData?.state} />
                    </Col>
                    <Col span={6}>
                      <Input value={formData?.postalCode} />
                    </Col>
                  </Row>
                </Input.Group>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={18}>
              <Form.Item label="상세설명" name="description">
                <Input.TextArea rows={5} />
              </Form.Item>
            </Col>
            <Col span={6}></Col>
          </Row>

          <Row justify="end" style={{ marginTop: '3rem' }}>
            <Form.Item>
              <Row gutter={12}>
                <Col>
                  <ButtonSubmit type="거절" state={formData?.accountState} />
                </Col>
                <Col>
                  <ButtonSubmit type="승인" state={formData?.accountState} />
                </Col>
              </Row>
            </Form.Item>
          </Row>
        </Form>
      </div>
    </>
  );
};

export default LogisticInformation;
